/*! transition-view.js */

import BaseView from "./base-view";
import PlaylistEvents from "app/events/playlist-events";

const BOUND_HANDLERS = [
    "onTransitionEnd",
    "onCancel",
    "onPlay"
];

const DEFAULT_TRANSITION_DURATION = 5000;
const CLICK = "click";

/**
 * @class TransitionView
 * @extends BaseView
 */
class TransitionView extends BaseView {

    /**
     * @constructs TransitionView
     */
    constructor(transitionDuration = DEFAULT_TRANSITION_DURATION) {
        super();

        BOUND_HANDLERS.forEach((handler) => {
            this[handler] = this[handler].bind(this);
        });

        this.animationDuration = transitionDuration;
        this.animationTimerId = null;
        this.title = this.find(".bvp-playback-transition__title");
        this.countdown = this.find(".autoplay-countdown");
        this.cancelButton = this.find(".bvp-playback-transition__cancel");
        this.playButton = this.find(".bvp-playback-transition__countdown");

        this.cancelButton.addEventListener(CLICK, this.onCancel);
        this.playButton.addEventListener(CLICK, this.onPlay);
    }

    /**
     * @override
     * @method
     * @return {Element}
     */
    createEl() {
        return super.createEl("div", "bvp-playback-transition", {
            innerHTML: `
        <div class="bvp-playback-transition__container">
            <div class="bvp-playback-transition__title"></div>
            <div class="bvp-playback-transition__buttons">
                <button class="bvp-playback-transition__countdown" aria-label="Play Next" title="Play Next">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97 97">
                      <circle class="autoplay-countdown" fill="none" stroke="#fff" stroke-width="4" transform="translate(48.5 48.5)rotate(-90)translate(-48.5 -48.5)" cx="48.5" cy="48.5" r="46" />
                      <path d="M37 34.5V62.5l25-13.1Z" fill="#fff"/>
                  </svg>
                </button>
                <button class="bvp-playback-transition__cancel" aria-label="Cancel Countdown" title="Cancel Countdown"></button>
            </div>
        </div>
        `.trim()
        });
    }

    /**
     * @method
     */
    animateTransition() {
        const animationElement = this.el_.getElementsByClassName("autoplay-countdown")[0];
        animationElement.style["animation-duration"] = `${ Math.floor(this.animationDuration / 1000) }s`;

        this.animationTimerId = setTimeout(() => {
            this.onTransitionEnd();
        }, this.animationDuration);
    }

    /**
     * @method
     */
    cancelTransition() {
        window.clearTimeout(this.animationTimerId);
        this.animationTimerId = null;
    }

    /**
     * @override
     */
    show() {
        this.animateTransition();
        super.show();
    }

    /**
     * @method
     * @param {string} title
     */
    setTitle(title) {
        this.title.textContent = title;
    }

    /**
     * @method
     * @param {string} poster Poster image url
     */
    setPoster(poster = "") {
        this.css({
            "background-image": `url(${ poster })`
        });
    }

    /**
     * @method
     * @param {string} id
     */
    setId(id) {
        this.id = id;
    }

    /**
     * @method
     */
    onCancel() {
        this.cancelTransition();
        this.trigger(PlaylistEvents.TRANSITION_CANCEL, { id: this.id });
    }

    /**
     * @method
     */
    onPlay() {
        this.cancelTransition();
        this.trigger(PlaylistEvents.TRANSITION_SKIP, { id: this.id });
    }

    /**
     * @method
     */
    onTransitionEnd() {
        this.trigger(PlaylistEvents.TRANSITION_END, { id: this.id });
    }

    /**
     * @override
     * @method
     */
    dispose() {
        this.cancelTransition();
        this.cancelButton.removeEventListener(CLICK, this.onCancel);
        this.playButton.removeEventListener(CLICK, this.onPlay);

        this.title = this.countdown = this.cancelButton = this.playButton = null;

        super.dispose();
    }
}

export default TransitionView;
